
const FieldChallenges = () => {
  const challenges = [
    {
      challenge: "Scale Formation & Deposition",
      impact: "Reduced production, equipment damage, increased maintenance costs",
      solution: "Custom scale inhibitor programs with real-time monitoring",
      result: "90-95% scale prevention, extended equipment life",
      image: "https://public.readdy.ai/ai/img_res/fd6982997332b8ea2b89f4b9f2074ec2.jpg"
    },
    {
      challenge: "Corrosion in Production Systems",
      impact: "Equipment failure, safety risks, production downtime",
      solution: "Comprehensive corrosion inhibition with monitoring systems",
      result: "80% reduction in corrosion rates, improved safety",
      image: "https://readdy.ai/api/search-image?query=Corrosion%20protection%20system%20with%20Golden%20Black%20technology%2C%20advanced%20inhibitor%20application%20preventing%20metal%20degradation%20in%20oil%20equipment&width=400&height=250&seq=corrosion-challenge&orientation=landscape"
    },
    {
      challenge: "Formation Damage",
      impact: "Reduced permeability, declining production rates",
      solution: "Matrix acidizing with formation-specific acid systems",
      result: "200-300% improvement in well productivity",
      image: "https://readdy.ai/api/search-image?query=Formation%20damage%20treatment%20with%20Golden%20Black%20acid%20systems%2C%20well%20stimulation%20operation%20restoring%20reservoir%20permeability%20and%20production&width=400&height=250&seq=formation-challenge&orientation=landscape"
    },
    {
      challenge: "Water Production Issues",
      impact: "Increased lifting costs, processing challenges",
      solution: "Water shut-off treatments and production optimization",
      result: "60% reduction in water cut, improved oil recovery",
      image: "https://readdy.ai/api/search-image?query=Water%20production%20control%20with%20Golden%20Black%20technology%2C%20advanced%20separation%20and%20treatment%20systems%20optimizing%20oil-water%20ratio&width=400&height=250&seq=water-challenge&orientation=landscape"
    },
    {
      challenge: "Bacterial Contamination",
      impact: "Souring, corrosion acceleration, equipment fouling",
      solution: "Targeted biocide programs with monitoring protocols",
      result: "99% bacterial reduction, eliminated souring issues",
      image: "https://readdy.ai/api/search-image?query=Bacterial%20contamination%20control%20with%20Golden%20Black%20biocide%20systems%2C%20advanced%20treatment%20preventing%20microbial%20growth%20in%20oil%20systems&width=400&height=250&seq=bacterial-challenge&orientation=landscape"
    },
    {
      challenge: "Emulsion Stability Problems",
      impact: "Processing difficulties, reduced oil quality",
      solution: "Custom demulsifier formulations and optimization",
      result: "95% water separation efficiency, improved oil quality",
      image: "https://readdy.ai/api/search-image?query=Emulsion%20breaking%20technology%20with%20Golden%20Black%20demulsifiers%2C%20advanced%20separation%20process%20improving%20oil-water%20separation%20efficiency&width=400&height=250&seq=emulsion-challenge&orientation=landscape"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Field Challenges Addressed
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Golden Black's expertise transforms complex oilfield challenges into optimized solutions, 
            delivering measurable improvements in production and operational efficiency.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {challenges.map((item, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src={item.image}
                alt={item.challenge}
                className="w-full h-48 object-cover"
              />
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">{item.challenge}</h3>
                
                <div className="space-y-4">
                  <div>
                    <h4 className="font-semibold text-red-600 mb-1 flex items-center">
                      <i className="ri-error-warning-line mr-2"></i>
                      Impact:
                    </h4>
                    <p className="text-gray-600 text-sm">{item.impact}</p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-blue-600 mb-1 flex items-center">
                      <i className="ri-lightbulb-line mr-2"></i>
                      Solution:
                    </h4>
                    <p className="text-gray-600 text-sm">{item.solution}</p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-green-600 mb-1 flex items-center">
                      <i className="ri-check-line mr-2"></i>
                      Result:
                    </h4>
                    <p className="text-green-700 text-sm font-medium">{item.result}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-teal-50 rounded-xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Facing Unique Field Challenges?
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Our technical team specializes in diagnosing and solving complex oilfield problems. 
              Contact us for a comprehensive assessment of your specific challenges.
            </p>
            <a 
              href="/consultation" 
              className="bg-teal-600 text-white px-8 py-3 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Request Technical Assessment
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FieldChallenges;
